<template>
  <div class="form-box">
    <el-form
      ref="form"
      :hide-required-asterisk="true"
      label-position="top"
      :rules="rules"
      label-width="200px"
      :model="form"
    >
      <el-form-item prop="userNo">
        <div slot="label">
          <div class="label-text">
            職員帳號
            <span class="star-mark">*</span>
          </div>
        </div>
        <el-input
        
          v-model="form.userNo"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <div slot="label">
          <div class="label-text">姓名</div>
        </div>
        <el-input
         
          v-model="form.name"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>

      <el-form-item>
        <div slot="label">
          <div class="label-text">電話</div>
        </div>
        <el-input
         
          v-model="form.phone"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <div slot="label">
          <div class="label-text">電郵</div>
        </div>
        <el-input
          
          v-model="form.email"
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="branchSchool">
        <div slot="label">
          <div class="label-text">分校<span class="star-mark">*</span></div>
        </div>
        <el-select
          :disabled="userInfoRoleRoleId ==teacherRoleId || userInfoRoleRoleId ==editorRoleId"
          value-key="id"
          clearable
          v-model="form.branchSchool"
          placeholder=""
        >
          <el-option
            v-for="(item, index) in sortBranchesList"
            :key="index"
            :label="item.abbreviation"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="roleId">
        <div slot="label">
          <div class="label-text">權限<span class="star-mark">*</span></div>
        </div>
        <el-select
          :disabled="userInfoRoleRoleId ==teacherRoleId || userInfoRoleRoleId ==editorRoleId"
          clearable
          v-model="form.roleId"
          placeholder="請選擇"
        >
          <el-option
            v-for="(item, index) in $store.getters.roles.filter((v)=>{
                   return v.name !=='Parent' && v.name !=='Student'
                })"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="password">
        <div slot="label">
          <div class="label-text">
            密碼
            <span  class="star-mark"> *</span>
          </div>
        </div>
        <el-input
          v-model="form.password"
          show-password
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <div slot="label">
          <div class="label-text">
            確認密碼
            <span  class="star-mark"> *</span>
          </div>
        </div>
        <el-input
          v-model="form.confirmPassword"
          @input="onChange"
          @change="onChange"
          show-password
          class="fixed-with-330-input"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.form.password === "") {
        callback(new Error("请輸入密码"));
      } else {
        if (this.form.confirmPassword != "") {
          this.$refs.form.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (this.form.confirmPassword == "") {
        callback(new Error("请再次輸入密码"));
      } else if (this.form.confirmPassword != this.form.password) {
        callback(new Error("Not the same as the password.和密碼不相同。"));
      } else {
        callback();
      }
    };
    return {
      statuses: [],
      rules: {
        username: [
          {
            required: true,
            message: "The username must be at least 4 digits.用户名称至少4位。",
            trigger: "change",
          },
          {
            min: 4,
            message: "The username must be at least 4 digits.用户名称至少4位。",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请輸入电邮", trigger: "change" },
          {
            type: "email",
            required: true,
            message: "Incorrect format.格式不正確。",
            trigger: "change",
          },
        ],
        password: [
          { validator: validatePass, trigger: "change" },
          {
            min: 8,
            message: "The password must be at least 8 digits.密碼至少8位。",
            trigger: "blur",
          },
        ],
        confirmPassword: [{ validator: validatePass2, trigger: "change" }],
        roleId: [{ required: true, message: "請選擇角色", trigger: "change" }],
        gender: [{ required: true, message: "請選擇性別", trigger: "change" }],
      },
    };
  },
  created() {},
  methods: {
    onChange() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  margin-top: 50px;
  overflow: hidden;
}

.label-text {
  font-size: 20px;
  line-height: 24px;
}

::v-deep {
  .el-input__inner {
    height: 53px;
  }
  .el-select {
    width: 330px;
  }
}

.fixed-with-330-input {
  width: 330px;
}

.fixed-with-141-input {
  width: 141px;
}

::v-deep {
  .el-form-item__content {
    line-height: 24px;
  }
}
.submitButton {
  width: 150px;
  margin-top: 10px;
}
</style>